import { memo } from 'react';

import { DownloadIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

export type DownloadButtonProps = Pick<Required<ButtonProps>, 'onClick'> & {
  hasMultiple: boolean;
};

export const DownloadButton = memo(({ hasMultiple, onClick }: DownloadButtonProps) => (
  <Button
    appearance="filled"
    color="gray"
    data-testid="SELECTION_ACTION_BAR_DOWNLOAD"
    onClick={onClick}
    prefix={<DownloadIcon size="xs" />}
    size="small"
  >
    {hasMultiple ? 'Download all' : 'Download'}
  </Button>
));

DownloadButton.displayName = 'DownloadButton';
